import React from "react";
import "./SelectionChipGrid.scss";

export type ChipOption = {
  id: string | number;
  label: string;
  disabled?: boolean;
};

type SelectionChipGridProps = {
  options: ChipOption[];
  selectedId: string | number | null | undefined;
  onSelect: (id: string | number) => void;
  rtl?: boolean;
  emptyMessage?: string;
};

const SelectionChipGrid: React.FC<SelectionChipGridProps> = ({
  options,
  selectedId,
  onSelect,
  rtl = false,
  emptyMessage,
}) => {
  if (!options?.length) {
    return emptyMessage ? (
      <p className={`selection-chip-grid__empty familysora400 ${rtl ? "text-right" : "text-left"}`}>
        {emptyMessage}
      </p>
    ) : null;
  }

  return (
    <div className={`selection-chip-grid ${rtl ? "selection-chip-grid--rtl" : ""}`}>
      {options.map((option) => {
        const isSelected = selectedId === option.id;
        return (
          <button
            key={option.id}
            type="button"
            disabled={option.disabled}
            className={`selection-chip-grid__chip familysora600 ${
              isSelected ? "selection-chip-grid__chip--selected" : ""
            } ${option.disabled ? "selection-chip-grid__chip--disabled" : ""}`}
            onClick={() => !option.disabled && onSelect(option.id)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default SelectionChipGrid;
